import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { PrerenderService } from '@df/browser/storage/prerender/prerender.service';
import { SsrService } from '@df/universal/client/ssr.service';
import { SsrShortcutsService } from './ssr-shortcuts.service';

export function provideDfSsr(): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: PrerenderService,
            useExisting: SsrService
        },
        provideAppInitializer(() => {
            inject(SsrService).init();
            inject(SsrShortcutsService).appInitializer();
        })
    ]);
}
